import { ArticleLayout, useSlug } from "../components/ArticleLayout";
import { INSIGHTS } from "../lib/data";

export default function InsightDetail() {
  const slug = useSlug();
  const item = INSIGHTS.find((c) => c.slug === slug);
  return <ArticleLayout item={item} kicker="Insight" backTo="/insights" backLabel="All insights" />;
}
